import React from 'react'
import './BotAvatar.css'
import tripzIcon from '../../images/tripz-icon.svg'
const BotAvatar = () => {
  return (
    <div className='tripz-avatar'>
      <img src={tripzIcon} alt='tripz-icon'/>
    </div>
  )
}

export default BotAvatar
